import styled from "styled-components";

export const ResolutionSection = styled.div`
    padding: 0px;
`;

export const ResolutionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
`;

export const ResolutionTitle = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #111;
`;

export const ResolutionDescription = styled.p`
    margin: 6px 0 0 0;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
`;

export const ResolutionBadge = styled.div`
    background: ${props =>
        props.$resolution <= 4 ? "#fff7e6" : props.$resolution <= 6 ? "#e6f7ff" : "#f6ffed"};
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    color: ${props =>
        props.$resolution <= 4 ? "#d46b08" : props.$resolution <= 6 ? "#096dd9" : "#389e0d"};
`;

export const OptionContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.2s;
    margin: 2px 0;
    border-radius: 18px !important;
`;

export const OptionIcon = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 20px;
    background: ${props =>
        props.$value <= 4 ? "#fff7e6" : props.$value <= 6 ? "#e6f7ff" : "#f6ffed"};
    border: 1px solid
        ${props => (props.$value <= 4 ? "#ffd591" : props.$value <= 6 ? "#91d5ff" : "#b7eb8f")};
    transition: all 0.2s;
`;

export const OptionContent = styled.div`
    flex: 1;
`;

export const OptionTitle = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: #262626;
`;

export const OptionDescription = styled.div`
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 2px;
`;

export const LabelStyled = styled.label`
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 32px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    margin-bottom: 0px;
`;

export const SelectStyles = `
   

    .resolution-select .ant-select-selector {
        border-radius: 12px !important;
        height: 44px !important;
        padding: 0 12px !important;
        border-color: #e8e8e8 !important;
    }

    .resolution-select .ant-select-arrow {
        right: 12px !important;
    }

    .resolution-select .ant-select-selection-item {
        line-height: 42px !important;
    }

    .resolution-select:hover .ant-select-selector {
        border-color: #40a9ff !important;
    }

    .resolution-select .ant-select-dropdown {
        padding: 4px !important;
        border-radius: 16px !important;
        box-shadow: 0 3px 12px rgba(0,0,0,0.1) !important;
        min-width: 280px !important;
        max-height: 400px !important;
        overflow-y: auto !important;
    }

    .resolution-select .ant-select-dropdown {
        border-radius: 16px !important;
    }

    .resolution-select .ant-select-item {
        padding: 0 !important;
    }

    .resolution-select .ant-select-item-option-active > div {
        background: #f5f5f5 !important;
    }

    .resolution-select .ant-select-item-option-selected > div {
        background: #e6f7ff !important;
    }
`;
